<ng-container *ngFor="let item of primaryNavItems; trackBy: trackById">
  <shrd-pf-ft-header-mega-menu-item
    *ngIf="isBrowser && item.childList?.length; else primaryNavLink"
    [item]="item"
  ></shrd-pf-ft-header-mega-menu-item>
  <ng-template #primaryNavLink>
    <a
      class="mega-menu-item py-0"
      [class.active]="item.active"
      shrdUicButton
      variant="headerNav"
      [href]="item.url"
      [shrdUtcTrackEvent]="{ category: 'SiteOperations', action: 'MainNavigation', label: item.title + '|L1' }"
    >
      <span>{{ item.title }}</span>
    </a>
  </ng-template>
</ng-container>
